export default process.env.NODE_ENV === 'production' ? 'https://coordsconverter.verdedata.ro' : 'http://localhost:3001'
// export default process.env.NODE_ENV === 'production' ? 'http://localhost:3001' : 'http://localhost:3001'
